import React from 'react';

import { Submission } from 'types/evaluation';

interface SearchFilterBarProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
  availableCategories: string[];
  submissions: Submission[];
}

// 1st Container: Title, Filter, Search Bar
const SearchFilterBar: React.FC<SearchFilterBarProps> = ({
  searchQuery,
  onSearchChange,
  selectedCategory,
  onCategoryChange,
  availableCategories,
  submissions,
}) => {
  return (
    <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
      <h2 className="text-2xl font-baijamjuree font-bold text-gray-900 mb-6">
        Final Round Evaluation
      </h2>

      {/* Search and Category Filter */}
      <div className="flex flex-col lg:flex-row gap-4 items-stretch lg:items-center">
        {/* Search Input */}
        <div className="flex-1 lg:flex-[2]">
          <div className="relative">
            <svg
              className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
            <input
              type="text"
              placeholder="Search submissions..."
              value={searchQuery}
              onChange={e => onSearchChange(e.target.value)}
              className="w-full pl-10 pr-4 py-2.5 rounded-lg border border-gray-300 bg-white font-baijamjuree text-sm text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
        </div>

        {/* Category Filter */}
        <div className="lg:flex-1">
          <select
            value={selectedCategory}
            onChange={e => {
              const category = e.target.value;
              onCategoryChange(category);
            }}
            className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2.5 text-sm font-baijamjuree text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            {availableCategories.map(category => {
              const categorySubmissions = submissions.filter(
                s => s.category === category
              );
              return (
                <option key={category} value={category}>
                  {category} ({categorySubmissions.length})
                </option>
              );
            })}
          </select>
        </div>
      </div>
    </div>
  );
};

export default SearchFilterBar;
